export const getCookie = (name: string): string | undefined => {
  // Runs a regex capturing group to extract (content) from ...cookieStuff....;name=(content);...moreCookieStuff...
  const cookieContentMatch = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return cookieContentMatch ? cookieContentMatch[2] : undefined;
};
